import { render, staticRenderFns } from "./ExpiredPassword.vue?vue&type=template&id=6961943c&"
import script from "./ExpiredPassword.vue?vue&type=script&lang=js&"
export * from "./ExpiredPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports